import { SvgIcon, SvgIconProps } from '@mui/material';

export const SendOutlinedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 -960 960 960" {...props}>
      <path d="M120-160v-640l760 320-760 320Zm80-120 474-200-474-200v140l240 60-240 60v140Zm0 0v-400 400Z" />
    </SvgIcon>
  );
};
